import { Grid } from "@boozallen-uip/uswds-react-core";
import React, { useCallback, useEffect, useState } from "react";
import { AdvancedTable } from "@boozallen-uip/uswds-react-table";
import useHyperlink from "../../hooks/useHyperlink.hook";
// import HyperlinkModal from "./HyperlinkModal";
export default function HyperlinkListContainer() {
  const [data, setData] = useState([]);
  const { getAllHyperlinks } = useHyperlink();

  const fetchHyperlinks = useCallback(() => {
    getAllHyperlinks()
      .then((response) => {
        setData(response);
      })
      .catch(() => {
        // Silently fail - this is for the hyperlinks list which is non-critical
      });
  }, [getAllHyperlinks]);

  useEffect(() => {
    fetchHyperlinks();
  }, [fetchHyperlinks]);

  const advancedTableColumns = {
    data: {
      productId: {
        displayName: 'Product Id',
        width: 200
      },
      name: {
        displayName: 'Name',
        width: 175
      },
      url: {
        displayName: 'Url',
        width: 275
      },
      feedbackURL: {
        displayName: 'feedbackURL',
        width: 200
      },
      type: {
        displayName: 'type',
        width: 100
      },
      submittedDate: {
        displayName: 'submittedDate',
        width: 175
      },
      expirationDate: {
        displayName: 'expirationDate',
        width: 175
      },
      isActive: {
        displayName: 'isActive',
        width: 125
      },
    },
    visibleOrder: ['productId', 'name', 'url', 'feedbackURL', 'type', 'submittedDate', 'expirationDate', 'isActive']
  };

  return (
    <div>
      <Grid>
        <h1>Hyperlinks</h1>
        <Grid.Row>
          <Grid.Col>
            <div>
              {/* <HyperlinkModal modalStateChanged={this.modalStateChanged} /> */}
            </div>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <br />
        </Grid.Row>
        <Grid.Col>
          <Grid.Row>
            <AdvancedTable
              columns={advancedTableColumns}
              data={data}
              loadNextPage={() => { }}
              tableInstance="test"
            />
          </Grid.Row>
        </Grid.Col>
      </Grid>
    </div>
  );
}
